import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackDownloadedTranscript.meta';

export type UseTrackDownloadedTranscriptParams = {
  clip_id: string;
  file_type: 'vtt' | 'srt';
};

export const useTrackDownloadedTranscript = () => {
  const { track } = useAnalyticsUtilities();

  const trackDownloadedTranscript = useCallback(
    (params: UseTrackDownloadedTranscriptParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackDownloadedTranscript };
};
